import { render, staticRenderFns } from "./AccessPageNext.vue?vue&type=template&id=2f7bb3ef&scoped=true"
import script from "./AccessPageNext.vue?vue&type=script&lang=js"
export * from "./AccessPageNext.vue?vue&type=script&lang=js"
import style0 from "./AccessPageNext.vue?vue&type=style&index=0&id=2f7bb3ef&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7bb3ef",
  null
  
)

export default component.exports